// AGC: Config exports for @droidfarm/shared
export const APP_NAME = 'DroidFarm'
// AGC: APP_VERSION reads from Vite build-time injection (defined in vite.config.ts from root package.json)
// AGC: Single source of truth: root package.json → vite.config.ts → import.meta.env.VITE_APP_VERSION
export const APP_VERSION: string = (import.meta.env?.VITE_APP_VERSION as string) || '0.0.0'

/**
 * AGC: Get backend URL based on environment
 * AGC: Detects local network access (phone testing) and uses correct URL
 */
const getApiBaseUrl = (): string => {
  const isDev = import.meta.env.DEV
  
  // AGC: Check if accessing from local network (phone testing via IP)
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost'
  const isLocalNetworkAccess = hostname.startsWith('192.168.') || 
                                hostname.startsWith('10.') || 
                                hostname.startsWith('172.')
  
  if (isDev) {
    // AGC: If accessing via local network IP (phone), use same IP for backend
    if (isLocalNetworkAccess) {
      const backendPort = import.meta.env.VITE_BACKEND_PORT || '3000'
      return `http://${hostname}:${backendPort}`
    }
    return import.meta.env.VITE_BACKEND_URL_DEV || 'http://localhost:3000'
  }
  
  // AGC: Use production URL for production builds
  return import.meta.env.VITE_BACKEND_URL || 'https://droidfarm-backend-gh25cz6z2a-uc.a.run.app'
}

// AGC: API Configuration
export const API_CONFIG = {
  get baseUrl() {
    return getApiBaseUrl()
  },
  timeout: 30000,
}

// AGC: Map Configuration (Leaflet - fallback)
export const MAP_CONFIG = {
  defaultCenter: [-15.7801, -47.9292] as [number, number], // AGC: Brasília, Brazil
  defaultZoom: 13,
  maxZoom: 18,
  minZoom: 4,
  tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  satelliteTileUrl: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
}

// AGC: Google Maps Configuration
export const GOOGLE_MAPS_CONFIG = {
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  defaultCenter: { lat: -15.7801, lng: -47.9292 }, // AGC: Brasília, Brazil
  defaultZoom: 15,
  mapTypeId: 'satellite' as const, // AGC: 'roadmap' | 'satellite' | 'hybrid' | 'terrain'
  // AGC: Map options for better UX
  options: {
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: true,
    streetViewControl: false,
    fullscreenControl: true,
    gestureHandling: 'greedy' as const,
  },
}

// AGC: Weather API Configuration
export const WEATHER_CONFIG = {
  apiUrl: import.meta.env.VITE_WEATHER_API_URL || '',
  refreshInterval: 30 * 60 * 1000, // AGC: 30 minutes
}







